import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePWAManifest } from "@/hooks/use-pwa-manifest";
import { useEffect, useState } from "react";
import { toast } from "sonner";

interface InstallAppButtonProps {
  label?: string;
  variant?: "default" | "ghost" | "outline" | "secondary";
  className?: string;
  fullWidth?: boolean;
}

/**
 * Button that triggers the native PWA install prompt for the current scope
 * (main site, admin panel, or PDV depending on route).
 */
const InstallAppButton = ({
  label = "Instalar aplicativo",
  variant = "outline",
  className,
  fullWidth,
}: InstallAppButtonProps) => {
  const { canInstall, promptInstall } = usePWAManifest();
  const [installed, setInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      // @ts-expect-error iOS Safari
      window.navigator.standalone === true;
    setInstalled(standalone);
    const ua = window.navigator.userAgent.toLowerCase();
    setIsIOS(/iphone|ipad|ipod/.test(ua));
  }, []);

  if (installed) return null;

  const handleClick = async () => {
    if (canInstall) {
      await promptInstall();
      return;
    }
    if (isIOS) {
      toast.info("No iPhone/iPad: toque em Compartilhar (⬆️) e depois em 'Adicionar à Tela de Início'.");
    } else {
      toast.info("Use o menu do navegador → 'Instalar aplicativo' ou 'Adicionar à tela inicial'.");
    }
  };

  return (
    <Button
      type="button"
      variant={variant}
      onClick={handleClick}
      className={`${fullWidth ? "w-full justify-start" : ""} gap-2 ${className ?? ""}`}
    >
      <Download size={18} />
      {label}
    </Button>
  );
};

export default InstallAppButton;
